/**
 * HomieTrack — AddToCart 統一 helper（Stage 2E,2026-05-07）
 *
 * 走 /api/track-event(fbCapi 系統),browser fbq + server CAPI 共用 event_id。
 *
 * 公開 API:
 *   window.HomieTrack.addToCart({
 *     variant_id: 12345,
 *     product_id: 678,
 *     title: '商品名',
 *     price: 1099,           // TWD 元(已 /100)
 *     quantity: 1,
 *     source: 'product-page' | 'floating-cart-inc' | 'theme-event'
 *   });
 *
 * 自動 hook:
 *   document 'cart:add'      → 觸發 addToCart(Shopify Dawn 主題 ThemeEvent)
 *   document 'cart:updated'  → 不觸發(廣義事件,可能是減量;floating-cart 自己處理)
 *
 * dedup:
 *   同 variant 30 秒窗口內只觸發 1 次。
 *   event_id = AddToCart_${variant_id}_${floor(now/30000)}
 *
 * Tesla 上 Shopify 載入方式(no defer,讓 window.HomieTrack 立刻可用):
 *   <script src="{{ 'homie-track.js' | asset_url }}"></script>
 */
(function () {
  'use strict';
  if (window.HomieTrack && window.HomieTrack.addToCart) return; // idempotent

  var CAPI_ENDPOINT = (window.COD_API_BASE || '') + '/api/track-event';
  var DEDUP_WINDOW_MS = 30 * 1000;
  var _lastFiredAt = {}; // key=variant_id, value=ts

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getFbp() { return getCookie('_fbp'); }
  function getFbc() {
    var fbc = getCookie('_fbc');
    if (fbc) return fbc;
    try {
      var fbclid = new URLSearchParams(window.location.search).get('fbclid');
      return fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : null;
    } catch (_) { return null; }
  }

  // TD-FUNNEL Phase 1b (2026-07-03): ATC 補 session_id。
  // 與 liquid/meta-pixel-tracking.js getOrCreateSessionId() 同一把 key "_hmSid"、
  // 同一種生成格式,確保同分頁 ATC 與 PV/VC/IC 落在同一 session。
  // 差異:sessionStorage 不可用時回 null(事件照發、只略過 session_id),
  // 不生成一次性隨機 sid,避免產生無法串接的孤兒 session 污染漏斗。
  function getSessionId() {
    try {
      var sid = sessionStorage.getItem('_hmSid');
      if (!sid) {
        sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem('_hmSid', sid);
      }
      return sid;
    } catch (e) {
      return null;
    }
  }

  function addToCart(item) {
    if (!item || !item.variant_id) return false;

    var key = String(item.variant_id);
    var now = Date.now();
    if (_lastFiredAt[key] && now - _lastFiredAt[key] < DEDUP_WINDOW_MS) {
      return false; // dedup window 內,靜默丟棄
    }
    _lastFiredAt[key] = now;

    var bucket = Math.floor(now / DEDUP_WINDOW_MS);
    var eventId = 'AddToCart_' + item.variant_id + '_' + bucket;

    var qty = Number(item.quantity) || 1;
    var price = Number(item.price) || 0;
    var value = price * qty;

    // 1. 瀏覽器 fbq
    if (typeof fbq === 'function') {
      try {
        fbq('track', 'AddToCart', {
          currency: 'TWD',
          value: value,
          content_type: 'product',
          content_ids: [String(item.variant_id)],
          content_name: item.title || '',
          contents: [{ id: String(item.variant_id), quantity: qty, item_price: price }]
        }, { eventID: eventId });
      } catch (_) { /* swallow */ }
    }

    // 2. server CAPI
    var body = {
      event_name: 'AddToCart',
      event_id: eventId,
      page_url: window.location.href,
      currency: 'TWD',
      value: value,
      num_items: qty,
      product_titles: [item.title || ''],
      contents: [{ id: String(item.variant_id), quantity: qty, item_price: price }]
    };
    var fbp = getFbp(); if (fbp) body.fbp = fbp;
    var fbc = getFbc(); if (fbc) body.fbc = fbc;
    var sid = getSessionId(); if (sid) body.session_id = sid;

    try {
      fetch(CAPI_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(function () { /* swallow */ });
    } catch (_) { /* swallow */ }

    // 2026-10-06 Clarity 事件標記（E-87）：加入購物車成功送出時；Clarity 沒載入不報錯、不送任何個資
    try { if (typeof window.clarity === 'function') window.clarity('event', 'add_to_cart'); } catch (_) {}

    return true;
  }

  function addToCartBundle(items) {
    if (!items || !items.length) return false;
    var sel = items.filter(function (it) {
      return it && it.variant_id && (Number(it.quantity) || 0) > 0;
    });
    if (!sel.length) return false;
    var contents = sel.map(function (it) {
      return { id: String(it.variant_id), quantity: Number(it.quantity) || 1, item_price: Number(it.price) || 0 };
    });
    var value = contents.reduce(function (s, c) { return s + c.item_price * c.quantity; }, 0);
    var numItems = contents.reduce(function (s, c) { return s + c.quantity; }, 0);
    var titles = sel.map(function (it) { return it.title || ''; });
    var key = 'bundle_' + sel.map(function (it) { return String(it.variant_id); }).sort().join('-');
    var now = Date.now();
    if (_lastFiredAt[key] && now - _lastFiredAt[key] < DEDUP_WINDOW_MS) return false;
    _lastFiredAt[key] = now;
    var eventId = 'AddToCart_' + key + '_' + Math.floor(now / DEDUP_WINDOW_MS);
    if (typeof fbq === 'function') {
      try {
        fbq('track', 'AddToCart', {
          currency: 'TWD', value: value, content_type: 'product',
          content_ids: contents.map(function (c) { return c.id; }),
          contents: contents
        }, { eventID: eventId });
      } catch (_) {}
    }
    var body = {
      event_name: 'AddToCart', event_id: eventId, page_url: window.location.href,
      currency: 'TWD', value: value, num_items: numItems,
      product_titles: titles, contents: contents
    };
    var fbp = getFbp(); if (fbp) body.fbp = fbp;
    var fbc = getFbc(); if (fbc) body.fbc = fbc;
    var sid = getSessionId(); if (sid) body.session_id = sid;
    try {
      fetch(CAPI_ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body), keepalive: true
      }).catch(function () {});
    } catch (_) {}
    // 2026-10-06 Clarity 事件標記（E-87）：加入購物車成功送出時；Clarity 沒載入不報錯、不送任何個資
    try { if (typeof window.clarity === 'function') window.clarity('event', 'add_to_cart'); } catch (_) {}
    return true;
  }

  // 內部 reset(只測試用,不對外暴露)
  function _resetDedupForTesting() { _lastFiredAt = {}; }

  // ── 全域 ThemeEvent listener(B 入口:Shopify Dawn 主題)────────
  // Stage 2E-1.5 (2026-05-07 Stage 2 正式版):Tesla probe 證實
  //   主題實際 dispatch 'cart:update'(單數)on <product-form-component>
  //   constructor=CartAddEvent、phase=capture(無 bubbles)
  //   → 必須用 { capture: true } 才能在 document 收到
  //
  // 兩個事件名掛同一個 handler:
  //   - 'cart:update'  ← 僅接受 product-form-component 的成功事件
  //   - 'cart:add'     ← Dawn 標準(向下相容,若未來改回)
  // 不再監聽 'cart:updated',因為減量與移除商品也會觸發。
  //
  // 防雙觸發:addToCart 內 30s _lastFiredAt[variant_id] dedup,
  //   即使兩個事件同時 fire 也只會送 1 次 server。
  //
  // 規避主題 bug:product-form.js:277 ThemePerformance.measureFromEvent
  //   會 throw SyntaxError → handler 全段 try-catch 不外溢
  //
  // Probe 保留:Tesla 驗證階段觀測用,確認後可改 debug-only

  // TD-28 (2026-05-12) — A 層 client DOM query fallback
  //   1202 主題的 CartAddEvent.detail = { resource, sourceId, data }(events.js:90)
  //   detail.item / detail.title / target.dataset.productTitle 全 undefined →
  //   原本 3 層 fallback 全 miss → title='' → server pixelMatcher 雙向 includes 全 match
  // Strategy:從 event.target 找最近 <product-form-component> 的 productId,
  //   再用 productId 限定 scope 找 [data-product-title](避開 collection 頁誤抓)
  function _resolveTitleFromDOM(target, productId) {
    if (!target || typeof target.closest !== 'function') return '';
    try {
      var pfc = target.closest('product-form-component');
      var pid = productId || (pfc && pfc.dataset && pfc.dataset.productId);
      if (!pid) return '';
      // 第一輪:strict selector — PDP COD 黑按鈕(buy-buttons.liquid:89-90 同 element 雙 attr)
      var sel = '[data-product-id="' + String(pid).replace(/"/g, '\\"') + '"][data-product-title]';
      var block = pfc && typeof pfc.closest === 'function'
        ? pfc.closest('.buy-buttons-block, .quick-add')
        : null;
      var el = (block && block.querySelector(sel)) || document.querySelector(sel);
      if (el && el.dataset && el.dataset.productTitle) return el.dataset.productTitle;
      // 第二輪:quick-add 結構 — wrapper 只有 title、product-form 只有 id(quick-add.liquid:62-69)
      //   pfc.closest('quick-add-component') scope 鎖當前卡,不會跨卡誤抓
      if (pfc) {
        var qac = pfc.closest('quick-add-component');
        if (qac && qac.dataset && qac.dataset.productTitle) return qac.dataset.productTitle;
      }
      return '';
    } catch (_) { return ''; }
  }

  function _cartEventHandler(eventName) {
    return function (e) {
      try {
        // Probe log(Tesla 驗證階段保留)
        try {
          console.log('[HomieTrack] ' + eventName + ' fired', {
            phase: e.eventPhase === 1 ? 'capture' : e.eventPhase === 2 ? 'target' : 'bubble',
            targetTag: e.target && (e.target.tagName || e.target.nodeName),
            constructor: e.constructor && e.constructor.name,
            detail: e && e.detail
          });
        } catch (_) {}

        var detail = (e && e.detail) || {};
        var target = e && e.target;
        var ds = (target && target.dataset) || {};
        var evData = detail.data || {};
        if (evData.didError) return;
        if (eventName === 'cart:update' && evData.source !== 'product-form-component') return;

        // 多重來源抽欄位:detail.item(Dawn) → detail 扁平 → target dataset →
        //   target 內 input[ref="variantId"](Tesla product-form 結構)
        var item = detail.item ||
                   (detail.items && detail.items[0]) ||
                   (detail.cart && detail.cart.items && detail.cart.items[0]) ||
                   detail;

        var variantInput = (target && target.querySelector)
          ? target.querySelector('input[ref="variantId"], input[name="id"]')
          : null;

        var variant_id = item.variant_id || item.id ||
                         ds.variantId || (variantInput && variantInput.value);
        var product_id = item.product_id || ds.productId;
        // TD-28 — 4 層 fallback:item.product_title → item.title → ds.productTitle → DOM query
        var title      = item.product_title || item.title || ds.productTitle ||
                         _resolveTitleFromDOM(target, product_id) || '';
        var quantity   = Number(item.quantity) || 1;

        // Dawn cart.js item.price 是 cents → /100 變元
        // 若 detail 沒帶 price(僅 dataset fallback)→ 0,不影響 event_id 去重
        var rawPrice = (item.price != null) ? Number(item.price) : NaN;
        var price    = isFinite(rawPrice) ? rawPrice / 100 : 0;

        if (!variant_id) {
          try { console.warn('[HomieTrack] ' + eventName + ' 無 variant_id,skip', { detail: detail, ds: ds }); } catch (_) {}
          return;
        }

        addToCart({
          variant_id: String(variant_id),
          product_id: product_id ? String(product_id) : undefined,
          title: title,
          price: price,
          quantity: quantity,
          source: 'theme-event-' + eventName
        });
      } catch (err) {
        try { console.warn('[HomieTrack] ' + eventName + ' handler error:', err); } catch (_) {}
      }
    };
  }

  // capture: true 必要 — Tesla 主題 dispatch 沒帶 bubbles
  document.addEventListener('cart:update',  _cartEventHandler('cart:update'),  { capture: true });
  document.addEventListener('cart:add',     _cartEventHandler('cart:add'),     { capture: true });

  window.HomieTrack = window.HomieTrack || {};
  window.HomieTrack.addToCart = addToCart;
  window.HomieTrack.addToCartBundle = addToCartBundle;
  window.HomieTrack._resetDedupForTesting = _resetDedupForTesting;
})();